module.exports = __webpack_public_path__ + "img/com.electrolux.scale.053f4985.webp";